<!-- Header -->
<div class="wrapper" [ngClass]="{'overflow-hidden': showMenu}" (onScroll)="onScroll($event)">
    
    <app-header [class.hide-nav]="hideNav"></app-header>
    <div class="spacer"></div>
    <router-outlet></router-outlet>
    
    <app-footer></app-footer>
</div>